import { render, staticRenderFns } from "./signatures-creation.vue?vue&type=template&id=3f4b884d&scoped=true&lang=html"
import script from "./signatures-creation.vue?vue&type=script&lang=js"
export * from "./signatures-creation.vue?vue&type=script&lang=js"
import style0 from "./signatures-creation.vue?vue&type=style&index=0&id=3f4b884d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4b884d",
  null
  
)

export default component.exports